import React from 'react';
import './HomeContent.css';

const HomeContent = () => {
  return (
    <div className="home-content">
      {/* The Best Free Section - Moved to Bottom */}
      <section className="content-section best-downloader-section">
        <div className="section-container">
          <h2 className="section-title">The Best Free YouTube & TikTok Video Downloader Online</h2>
          <p className="section-subtitle">Download your favorite videos from YouTube and TikTok in HD quality without watermarks. Our free online video downloader tool is fast, secure, and works on all devices. No registration required, no software installation needed - just paste the URL and download instantly.</p>
          
          <div className="best-downloader-grid">
            <div className="downloader-card">
              <span className="downloader-icon">🎬</span>
              <h3>YouTube Video Downloader</h3>
              <p>Download YouTube videos in multiple formats including MP4, MP3, and various quality options from 144p to 4K Ultra HD. Save YouTube Shorts, music videos, tutorials, and more directly to your device for offline viewing.</p>
            </div>

            <div className="downloader-card">
              <span className="downloader-icon">🎵</span>
              <h3>TikTok Video Downloader</h3>
              <p>Download TikTok videos without watermark in HD quality. Save your favorite TikTok content, trending videos, and viral clips to watch offline anytime. Our TikTok downloader removes watermarks automatically for clean downloads.</p>
            </div>

            <div className="downloader-card">
              <span className="downloader-icon">⚡</span>
              <h3>Fast & Free Forever</h3>
              <p>Experience lightning-fast download speeds with our optimized video downloader. Completely free to use with no hidden fees, no registration required, and unlimited downloads. Download as many videos as you want, whenever you want.</p>
            </div>
          </div>

          <div className="feature-list">
            <div className="feature-list-item">
              <h4>✓ HD Quality Downloads</h4>
              <p>Download videos in 1080p, 2K, 4K quality</p>
            </div>
            <div className="feature-list-item">
              <h4>✓ No Watermark</h4>
              <p>Clean downloads without watermarks</p>
            </div>
            <div className="feature-list-item">
              <h4>✓ All Devices Supported</h4>
              <p>Works on PC, Mac, Android, iPhone, iPad</p>
            </div>
            <div className="feature-list-item">
              <h4>✓ 100% Safe & Secure</h4>
              <p>No malware, no viruses, secure downloads</p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="content-section features-section">
        <div className="section-container">
          <h2 className="section-title">Why Choose Our Video Downloader?</h2>
          <p className="section-subtitle">The most powerful and user-friendly video downloader online</p>
          
          <div className="features-grid">
            <div className="feature-card">
              <span className="feature-icon">🎬</span>
              <h3>HD Quality Videos</h3>
              <p>Download videos in high definition quality including 1080p, 2K, and 4K Ultra HD resolution.</p>
            </div>
            
            <div className="feature-card">
              <span className="feature-icon">📹</span>
              <h3>MP4 & MP3 Format</h3>
              <p>Save videos in MP4 format or extract audio as MP3. Multiple format options available.</p>
            </div>
            
            <div className="feature-card">
              <span className="feature-icon">✨</span>
              <h3>No Watermark</h3>
              <p>Download TikTok videos without watermarks. Get clean, professional-looking videos.</p>
            </div>
            
            <div className="feature-card">
              <span className="feature-icon">💯</span>
              <h3>100% Free</h3>
              <p>Completely free to use with no hidden fees, no registration, and no subscription required.</p>
            </div>
            
            <div className="feature-card">
              <span className="feature-icon">📱</span>
              <h3>All Devices</h3>
              <p>Works perfectly on PC, Mac, Android, iPhone, iPad, and all mobile devices.</p>
            </div>
            
            <div className="feature-card">
              <span className="feature-icon">⚡</span>
              <h3>Fast & Secure</h3>
              <p>Lightning-fast downloads with secure HTTPS connection. Your privacy is protected.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="content-section faq-section">
        <div className="section-container">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">Everything you need to know about our video downloader</p>
          
          <div className="faq-grid">
            <div className="faq-item">
              <h3>Do I need a TikTok account to download videos?</h3>
              <p>No, you don't need a TikTok account. Simply paste the video URL and download instantly without logging in.</p>
            </div>
            
            <div className="faq-item">
              <h3>What video formats are supported?</h3>
              <p>We support MP4 video format and MP3 audio format. You can download videos in various quality options from 144p to 4K.</p>
            </div>
            
            <div className="faq-item">
              <h3>Can I download TikTok videos without watermark?</h3>
              <p>Yes! Our TikTok downloader automatically removes watermarks, giving you clean videos perfect for reposting or editing.</p>
            </div>
            
            <div className="faq-item">
              <h3>Is there a download limit?</h3>
              <p>No limits! Download as many YouTube and TikTok videos as you want. Enjoy unlimited downloads completely free.</p>
            </div>
            
            <div className="faq-item">
              <h3>Is it safe to use this downloader?</h3>
              <p>Absolutely! We use secure HTTPS encryption and don't store any of your data. No malware, no viruses, 100% safe.</p>
            </div>
            
            <div className="faq-item">
              <h3>Do I need to install any software?</h3>
              <p>No installation required! Our online video downloader works directly in your browser. Just paste the URL and download.</p>
            </div>
            
            <div className="faq-item">
              <h3>Can I download YouTube Shorts?</h3>
              <p>Yes! Our downloader supports YouTube Shorts, regular YouTube videos, music videos, and all other YouTube content.</p>
            </div>
            
            <div className="faq-item">
              <h3>What devices are supported?</h3>
              <p>All devices! Works on Windows PC, Mac, Linux, Android phones, iPhones, iPads, and tablets. Any device with a browser.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Unlimited Downloads Notice */}
      <section className="content-section unlimited-section">
        <div className="section-container">
          <div className="unlimited-card">
            <span className="unlimited-icon">🚀</span>
            <h2>Unlimited Downloads, Forever Free</h2>
            <p>Download as many YouTube and TikTok videos as you want without any restrictions. No registration, no payment, no limits. Enjoy unlimited access to our fast and secure video downloader service completely free, forever.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomeContent;
